export const heidiLogoMarkBaseClass = 'inline-block shrink-0 text-text-primary';
